import {
  FETCH_TASKS,
  FETCH_TASKS_SUCCESS,
  FETCH_TASKS_FAILED,
  ACCEPT_TASK,
  CANCEL_TASK,
  FETCH_NEW_BOOKINGS_SUCCESS
} from "../store/types";
import store from "../store/store";
import { updateProfile } from "./authactions";
import { RequestPushMsg } from "../other/NotificationFunctions";
import { firebase } from '../config/configureFirebase';
import { onValue, runTransaction, get, off, push, update, set } from "firebase/database";

const localIgnoredBookings = new Set();

const checkBookingMatchesDriver = (b, userInfo, settings) => {
  if (!b || !userInfo) return false;

  // If carType_required setting is enabled, driver must have an approved car
  if (settings && settings.carType_required && userInfo.carApproved === false) {
    return false;
  }

  // Category match: driver's active vehicle category must match booking category
  if (b.category) {
    if (!userInfo.category || userInfo.category !== b.category) {
      return false;
    }
  }

  // Vehicle type match: driver's active vehicle type must match booking's carType
  if (b.carType) {
    if (!userInfo.carType) {
      return false;
    }
    if (settings && settings.booking_high_to_low && b.capacity && userInfo.activeCar_position !== undefined) {
      if (userInfo.activeCar_position < b.capacity) {
        return false;
      }
    } else if (b.carType !== userInfo.carType) {
      return false;
    }
  }

  return true;
};

export const fetchTasks = () => (dispatch) => {
  const { auth, tasksRef, userRatingsRef, singleUserRef } = firebase;

  const uid = auth.currentUser.uid;
  off(tasksRef());
  dispatch({
    type: FETCH_TASKS,
    payload: null,
  });

  get(userRatingsRef(uid)).then((ratingSnap) => {
    let blockedFromRatings = {};
    if (ratingSnap.exists()) {
      const ratingsObj = ratingSnap.val();
      Object.values(ratingsObj).forEach((item) => {
        if (item.rate && item.rate <= 2 && item.user) {
          blockedFromRatings[item.user] = true;
        }
      });
      if (Object.keys(blockedFromRatings).length > 0) {
        update(singleUserRef(uid), { blockedCustomers: blockedFromRatings });
      }
    }

    onValue(tasksRef(), (snapshot) => {
      if (snapshot.val()) {
        let data = snapshot.val();
        const userInfo = store.getState().auth.profile || {};
        const completedBookings = store.getState().bookinglistdata?.bookings || [];
        const mergedBlocked = {
          ...(userInfo.blockedCustomers || {}),
          ...blockedFromRatings
        };
        completedBookings.forEach((b) => {
          if (b.rating && parseFloat(b.rating) <= 2 && b.customer) {
            mergedBlocked[b.customer] = true;
          }
        });

        const settings = store.getState().settingsdata?.settings || {};
        const arr = Object.keys(data)
          .filter((i) => {
            const b = data[i];
            const isRequested = Boolean(b.requestedDrivers && b.requestedDrivers[uid]);
            const isBlocked = Boolean(b.customer && mergedBlocked[b.customer]);
            const isIgnored = Boolean((b.ignoredDrivers && b.ignoredDrivers[uid]) || localIgnoredBookings.has(i) || (b.id && localIgnoredBookings.has(b.id)));
            const matchesVehicle = checkBookingMatchesDriver(b, userInfo, settings);
            return isRequested && !isBlocked && !isIgnored && matchesVehicle;
          })
          .map((i) => {
            data[i].id = i;
            return data[i];
          });

        let heatpoints = [];
        let bookings = Object.values(snapshot.val());
        for (let i = 0; i < bookings.length; i++) {
          if (bookings[i].status == 'NEW' && ((userInfo.hasOwnProperty('carType') && userInfo.carType === bookings[i].carType) || !userInfo.hasOwnProperty('carType'))) {
            if (bookings[i].customer && mergedBlocked[bookings[i].customer]) continue;
            heatpoints.push({ latitude: bookings[i].pickup.lat, longitude: bookings[i].pickup.lng, weight: 1 });
          }
        }
        dispatch({
          type: FETCH_NEW_BOOKINGS_SUCCESS,
          payload: heatpoints
        });

        dispatch({
          type: FETCH_TASKS_SUCCESS,
          payload: arr,
        });
      } else {
        dispatch({
          type: FETCH_TASKS_FAILED,
          payload: store.getState().languagedata.defaultLanguage.no_tasks,
        });
      }
    });
  }).catch(() => {
    onValue(tasksRef(), (snapshot) => {
      if (snapshot.val()) {
        let data = snapshot.val();
        const userInfo = store.getState().auth.profile || {};
        const settings = store.getState().settingsdata?.settings || {};
        const arr = Object.keys(data)
          .filter((i) => {
            const b = data[i];
            const isRequested = Boolean(b.requestedDrivers && b.requestedDrivers[uid]);
            const isBlocked = Boolean(userInfo && userInfo.blockedCustomers && b.customer && userInfo.blockedCustomers[b.customer]);
            const isIgnored = Boolean((b.ignoredDrivers && b.ignoredDrivers[uid]) || localIgnoredBookings.has(i) || (b.id && localIgnoredBookings.has(b.id)));
            const matchesVehicle = checkBookingMatchesDriver(b, userInfo, settings);
            return isRequested && !isBlocked && !isIgnored && matchesVehicle;
          })
          .map((i) => {
            data[i].id = i;
            return data[i];
          });

        dispatch({
          type: FETCH_TASKS_SUCCESS,
          payload: arr,
        });
      }
    });
  });
};

export const acceptTask = (task) => (dispatch) => {
  const { auth, trackingRef, singleUserRef, singleBookingRef } = firebase;

  const uid = auth.currentUser.uid;

  onValue(singleUserRef(uid), (snapshot) => {
    let profile = snapshot.val();

    runTransaction(singleBookingRef(task.id),(booking) => {
      let fleetCommission_fee= profile.fleetadmin ? ((parseFloat(booking.estimate) - parseFloat(booking.convenience_fees)) * parseFloat(booking.fleet_admin_comission) / 100).toFixed(2):0;
      let driver_fee = parseFloat(parseFloat(booking.estimate) - (parseFloat(booking.convenience_fees) + parseFloat(fleetCommission_fee) )).toFixed(2);
        if (booking && booking.requestedDrivers) {
          booking.driver = uid;
          booking.driver_image = profile.profile_image ? profile.profile_image : "";
          booking.car_image =  profile.car_image ? profile.car_image : "";
          booking.driver_name = profile.firstName + " " + profile.lastName;
          booking.driver_contact = profile.mobile;
          booking.driver_token = profile.pushToken ? profile.pushToken : '';
          booking.vehicle_number = profile.vehicleNumber ? profile.vehicleNumber : "";
          booking.vehicle_make = profile.vehicleMake ? profile.vehicleMake : "";
          booking.vehicle_model = profile.vehicleModel ? profile.vehicleModel : "";
          booking.vehicle_color = profile.car_color ? profile.car_color : (profile.vehicle_color ? profile.vehicle_color : (profile.vehicleColor ? profile.vehicleColor : ""));
          booking.car_color = booking.vehicle_color;
          booking.driverRating = profile.rating ? profile.rating : "0";
          booking.driver_verified = profile.approved ? true : false;
          booking.fleetadmin = profile.fleetadmin ? profile.fleetadmin : "";
          booking.driver_share = driver_fee;
          booking.fleetCommission= profile.fleetadmin ? ((parseFloat(booking.estimate) - parseFloat(booking.convenience_fees)) * parseFloat(booking.fleet_admin_comission) / 100).toFixed(2):null,
          booking.status = "ACCEPTED";
          booking.driverDeviceId = task.driverDeviceId? task.driverDeviceId: null;
          booking.requestedDrivers = null;
          booking.driverEstimates = null;
          return booking;
        }
      })
      .then(() => {
        get(singleBookingRef(task.id))
          .then((snapshot) => {
            if (!snapshot.exists()) {
              return;
            } else {
              let requestedDrivers =
                snapshot.val() && snapshot.val().requestedDrivers;
              let driverId = snapshot.val() && snapshot.val().driver;

              if (requestedDrivers == undefined && driverId === uid) {
                updateProfile({ queue: false })(dispatch);
                if(task.customer_token){
                  RequestPushMsg(task.customer_token, {
                    title:
                      store.getState().languagedata.defaultLanguage
                        .notification_title,
                    msg:
                    profile.firstName +
                      store.getState().languagedata.defaultLanguage
                        .accept_booking_request,
                    screen: "BookedCab",
                    params: { bookingId: task.id },
                  });
                }

                const driverLocation = store.getState().gpsdata.location;

                push(trackingRef(task.id), {
                  at: new Date().getTime(),
                  status: "ACCEPTED",
                  lat: driverLocation.lat,
                  lng: driverLocation.lng,
                });

                dispatch({
                  type: ACCEPT_TASK,
                  payload: { task: task },
                });
              }
            }
          })
          .catch((error) => {
            console.error(error);
          });
      });
  },{onlyOnce:true});
};

export const cancelTask = (bookingId) => (dispatch) => {
  const { auth, singleBookingRef, ignoredDriverRef } = firebase;

  const uid = auth.currentUser.uid;

  if (bookingId) {
    localIgnoredBookings.add(bookingId);
  }

  // Always dispatch CANCEL_TASK immediately so the task is removed from local Redux state.
  // This prevents the booking from lingering in the UI while the transaction completes.
  dispatch({
    type: CANCEL_TASK,
    payload: { uid: uid, bookingId: bookingId },
  });

  if (ignoredDriverRef && bookingId) {
    set(ignoredDriverRef(bookingId, uid), true).catch(() => {});
  }

  runTransaction(singleBookingRef(bookingId), (booking) => {
      if (booking) {
        // Mark this driver as having ignored/dismissed this booking.
        // This prevents the bookingScheduler from re-dispatching it to the same driver.
        if (!booking.ignoredDrivers) {
          booking.ignoredDrivers = {};
        }
        booking.ignoredDrivers[uid] = true;

        // Handle case where driver is assigned to the booking (ACCEPTED, PAYMENT_PENDING, etc.)
        if (booking.driver === uid && booking.status !== 'NEW') {
          booking.status = "NEW";
          booking.requestedDrivers = null;
          booking.driverEstimates = null;
          // Clear driver-related fields when canceling acceptance
          booking.driver = null;
          booking.driver_image = null;
          booking.car_image = null;
          booking.driver_name = null;
          booking.driver_contact = null;
          booking.driver_token = null;
          booking.vehicle_number = null;
          booking.vehicle_make = null;
          booking.vehicle_model = null;
          booking.driverRating = null;
          booking.driver_verified = null;
          booking.fleetadmin = booking.fleetadminrider ? booking.fleetadminrider : null;
          booking.driver_share = null;
          booking.fleetCommission = null;
          booking.driverDeviceId = null;
          if(booking.customer_token){
            RequestPushMsg(booking.customer_token, {
              title:
                store.getState().languagedata.defaultLanguage.notification_title,
              msg:
                store.getState().languagedata.defaultLanguage.booking_cancelled +
                bookingId,
              screen: "BookedCab",
              params: { bookingId: bookingId },
            });
          }
        } else if (booking.requestedDrivers) {
          // Handle NEW bookings with requestedDrivers
          if (
            booking.requestedDrivers !== null &&
            Object.keys(booking.requestedDrivers).length === 1 &&
            booking.requestedDrivers[uid]
          ) {
            // This driver is the only requested driver — clear requestedDrivers
            // so the bookingScheduler can re-dispatch to other nearby drivers.
            booking.requestedDrivers = null;
            booking.driverEstimates = null;
          } else {
            // Multiple drivers requested — just remove this driver from the list
            delete booking.requestedDrivers[uid];
            if (booking.driverEstimates && booking.driverEstimates[uid]) {
              delete booking.driverEstimates[uid];
            }
          }
          if(booking.driverOffers && booking.driverOffers[uid]){
            delete booking.driverOffers[uid];
          }
          if(booking.selectedBid && booking.selectedBid.driver === uid){
            delete booking.selectedBid;
          }
        } else {
          // Edge case: booking is NEW but has no requestedDrivers and driver is not assigned.
          // Just remove driver's offers/bids if any exist.
          if(booking.driverOffers && booking.driverOffers[uid]){
            delete booking.driverOffers[uid];
          }
          if(booking.driverEstimates && booking.driverEstimates[uid]){
            delete booking.driverEstimates[uid];
          }
          if(booking.selectedBid && booking.selectedBid.driver === uid){
            delete booking.selectedBid;
          }
        }
        return booking;
      }
    }).catch((err) => {
      console.log("cancelTask transaction error:", err);
    });
};
